import { render, staticRenderFns } from "./newPressesionStepTwo.vue?vue&type=template&id=7cc50dea&scoped=true&"
import script from "./newPressesionStepTwo.vue?vue&type=script&lang=js&"
export * from "./newPressesionStepTwo.vue?vue&type=script&lang=js&"
import style0 from "./newPressesionStepTwo.vue?vue&type=style&index=0&id=7cc50dea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc50dea",
  null
  
)

export default component.exports